import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Seo from "@/components/Seo";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Residences from "@/components/Residences";
import Manifesto from "@/components/Manifesto";
import Amenities from "@/components/Amenities";
import Inquiry from "@/components/Inquiry";
import AtAGlance from "@/components/AtAGlance";
import Reviews from "@/components/Reviews";
import AreaGuide from "@/components/AreaGuide";
import Host from "@/components/Host";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ManagePhotos from "@/components/ManagePhotos";
import MaintenancePage from "@/components/MaintenancePage";
import ReviewPage from "@/components/ReviewPage";

function Landing({ residence, onResidenceChange }) {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative text-[#f7f2e7] antialiased">
      <div
        aria-hidden="true"
        className="fixed inset-0 -z-10 bg-cover bg-center scale-105"
        style={{ backgroundImage: "url('/images/abstract-bg.jpg')" }}
      />
      <Seo
        title="Parker Furnished Stays — Boutique Furnished Residences in Louisiana"
        siteName="Parker Furnished Stays"
        description="Distinctive furnished residences in Baker & Ascension Parish, Louisiana. De La Vie Maison, Heritage and Hearthstead Cottage — thoughtfully hosted for groups, teams, families and extended stays."
        image="/images/p-delavie-living.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Parker Furnished Stays",
          slogan: "Distinctive Residences. Thoughtfully Hosted.",
          areaServed: ["Baker, LA", "Ascension Parish, LA"],
        }}
      />
      <Nav />
      <main>
        <Hero />
        <AtAGlance />
        <Marquee />
        <Residences onEnquire={onResidenceChange} />
        <Reviews />
        <Manifesto />
        <Amenities />
        <AreaGuide />
        <Host />
        <Inquiry residence={residence} onResidenceChange={onResidenceChange} />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  const [residence, setResidence] = useState("De La Vie Maison");

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Landing residence={residence} onResidenceChange={setResidence} />}
        />
        <Route path="/manage-photos" element={<ManagePhotos />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route path="/review" element={<ReviewPage />} />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}
